
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/.well-known/apple-developer-merchantid-domain-association.txt",
      function () {
        return require("private-next-pages/.well-known/apple-developer-merchantid-domain-association.txt.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/.well-known/apple-developer-merchantid-domain-association.txt"])
      });
    }
  